import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import logoSP from '../../assets/images/logos/logo-padocaria-sp-26.webp';
import logoBH from '../../assets/images/logos/logo-padocaria-bh-26.webp';

import '../../assets/scss/components/SeletorCidade.scss';

const cidades = [
  {
    slug: 'sao-paulo',
    nome: 'São Paulo',
    logo: logoSP,
    logoAlt: 'Logo Padocaria SP',
    rota: '/sao-paulo',
    labelBotao: 'Votar em SP | Guarulhos'
  },
  {
    slug: 'belo-horizonte',
    nome: 'Belo Horizonte',
    logo: logoBH,
    logoAlt: 'Logo Padocaria BH',
    rota: '/belo-horizonte',
    labelBotao: 'Votar em BH'
  }
];

const SeletorCidade = ({ titulo }) => {
  const history = useHistory();

  return (
    <div className="seletor-cidade">
      <p className="seletor-cidade__titulo">
        {titulo || 'Escolha abaixo o local onde quer votar:'}
      </p>
      <div className="seletor-cidade__grid">
        {cidades.map((cidade) => (
          <button
            type="button"
            id={`btn-votar-${cidade.slug}`}
            key={cidade.slug}
            onClick={() => history.push(cidade.rota)}
            className="seletor-cidade__card"
          >
            <div className="seletor-cidade__card-logo">
              <img src={cidade.logo} alt={cidade.logoAlt} />
            </div>
            <div className="seletor-cidade__botao">{cidade.labelBotao}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

SeletorCidade.propTypes = {
  titulo: PropTypes.string
};

SeletorCidade.defaultProps = {
  titulo: null
};

export default SeletorCidade;
